import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SendMessageStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.2424 1.36161C21.6856 0.846302 23.0806 2.18021 22.6828 3.61845L22.6389 3.7581L16.3 21.5061C15.6688 23.2719 13.1226 23.1198 12.7062 21.2913L12.7053 21.2893L10.8723 13.1272L2.71113 11.2952L2.71016 11.2942C0.880992 10.8784 0.727938 8.33167 2.49434 7.70048L20.2424 1.36161ZM21.2258 3.25322C21.3319 2.95545 21.045 2.66867 20.7473 2.7747L2.99922 9.11259C2.64596 9.23876 2.67633 9.74813 3.04219 9.83134L11.2609 11.678L14.4699 8.47001C14.7628 8.17712 15.2376 8.17712 15.5305 8.47001C15.8231 8.76293 15.8233 9.23774 15.5305 9.53056L12.3215 12.7386L14.1691 20.9583L14.1896 21.0227C14.3147 21.3259 14.7695 21.3323 14.8879 21.0013L21.2258 3.25322Z"
				fill="currentColor"
			/>
		</svg>
	);
}

SendMessageStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SendMessageStrokeIcon;
